<h3>{{ idEnModification !== null ? ('admin.art.modifierTitre' | traduire) : ('admin.art.ajouter' | traduire) }}</h3>

<form class="form-ajout" (ngSubmit)="validerFormulaire()">
  <div class="ligne">
    <div>
      <label>{{ 'admin.art.nom' | traduire }}</label>
      <input type="text" [(ngModel)]="formArtiste.nom" name="nom" required>
    </div>
    <div>
      <label>{{ 'admin.art.role' | traduire }}</label>
      <input type="text" [(ngModel)]="formArtiste.role" name="role" [placeholder]="'admin.art.rolePlaceholder' | traduire">
    </div>
  </div>

  <label>{{ 'admin.art.bio' | traduire }}</label>
  <textarea [(ngModel)]="formArtiste.bio" name="bio" rows="3"></textarea>

  <app-photo-uploader [label]="'admin.art.photo' | traduire" [value]="formArtiste.photoUrl" (valueChange)="formArtiste.photoUrl = $event"></app-photo-uploader>
  <p class="confirmation" *ngIf="messageConfirmation">{{ messageConfirmation }}</p>

  <div class="boutons-form">
    <button type="submit">{{ idEnModification !== null ? ('admin.art.enregistrerModifs' | traduire) : ('admin.art.ajouterBtn' | traduire) }}</button>
    <button type="button" class="btn-annuler" *ngIf="idEnModification !== null" (click)="annulerModification()">{{ 'admin.art.annuler' | traduire }}</button>
  </div>
</form>

<h3>{{ 'admin.art.existants' | traduire }}</h3>

<div class="filtre-barre">
  <input type="text" [(ngModel)]="texteRecherche" [placeholder]="'🔍 ' + ('admin.art.rechercher' | traduire)">
</div>

<table class="table-liste">
  <thead>
    <tr>
      <th>{{ 'admin.art.nom' | traduire }}</th>
      <th>{{ 'admin.art.role' | traduire }}</th>
      <th></th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let artiste of artistesFiltres">
      <td>{{ artiste.nom }}</td>
      <td>{{ artiste.role }}</td>
      <td>
        <button class="btn-modifier" (click)="modifierArtiste(artiste)">{{ 'admin.art.modifier' | traduire }}</button>
        <button class="btn-supprimer" (click)="supprimerArtiste(artiste)">{{ 'admin.art.supprimer' | traduire }}</button>
      </td>
    </tr>
    <tr *ngIf="artistesFiltres.length === 0">
      <td colspan="3" style="text-align:center; color:#888;">{{ 'admin.art.aucunResultat' | traduire }}</td>
    </tr>
  </tbody>
</table>
